import React from "react";
import {ChipLabel} from "./index";

const DraftTypeChip = ({type}) => {
    const typeData = {
        "create": {
            class: "status-chip create",
            text: "Create"
        },
        "update": {
            class: "status-chip secondary",
            text: "Update"
        },
    }

    return (<ChipLabel label={typeData[type]?.text} className={typeData[type]?.class}/>)
}

export default DraftTypeChip;